import 'aliyun-webrtc-sdk'
import WebRtcService from '../services/webRtc.service'

export default class RTCClient {
  constructor() {
    this._client = new AliRtcEngine();
    window.rtcClient = this._client;

    this._callBack = null; // 回调
    this._isInCall = false;// 是否在频道里
    this._isPublish = false;// 是否推流
    this._isAudioOnlyMode = false;// 是否是纯音频模式
    this._autoPublish = true;// 自动推流
    this._autoSubscribe = true;// 自动订阅
    this._isPreview = false;// 是否开启了预览
    this._videoDevice = false;// 摄像头是否可用
    this._isMuteLocalMic = false; //是否采集本地音频
    this._isMuteLocalCamera = false; //是否采集本地摄像头
    this._isScreenSharePreview = false;//是否开启了屏幕分享预览

    // 设置屏幕共享时的分辨率
    this._setScreenShareResolution()
    // 添加事件回调
    this._handleEvents()
  }

  /**
   * 获取实例
   */
  static get instance() {
    if (!RTCClient._instance) {
      // console.log('rtc client is not exists ,create new client')
      RTCClient._instance = new RTCClient();
    }

    return RTCClient._instance
  }

  /**
   * 获取是否在频道中
   */
  get isInCall() {
    return this._isInCall;
  }

  /**
   * 获取是否在推流
   */
  get isPublish() {
    return this._isPublish;
  }

  /**
   * 获取预览状态
   */
  get isPreview() {
    return this._isPreview;
  }

  /**
   * 获取是否mute  视频
   */
  get isMuteLocalCamera() {
    return this._isMuteLocalCamera;
  }

  /**
   * 获取是否mute  音频
   */
  get isMuteLocalMic() {
    return this._isMuteLocalMic;
  }

  /**
   * 显示错误信息
   * @param {*} err
   */
  _showErrorMsg(error) {
    if (this._callBack) {
      this._callBack("onError", error);
    }
    console.error(error);
  }

  /**
   * isSupport webrtc能力检测
   */
  isSupport() {
    return new Promise((resolve, reject) => {
      const supportOptions = {
        isReceiveOnly: false,             // 是否为纯订阅模式
        customPlay: false ,               // 是否为自定义播放模式
        autoPublish: false,               // 是否入会后自动推流
        autoSubscribe: false,             // 是否自动订阅其他用户的可订阅的流
        autoPreferSubscribeMaster: false // 是否优先自动订阅大流（前提：autoSubscribe 为 true）
      }
      // 线上环境必须使用HTTPS协议。您可以添加{isDebug: true}参数进行localhost（本地主机）调试跳过HTTPS协议检测。
      //检测浏览器是否支持Web SDK。
      this._client.isSupport().then((re) => {
        resolve(re);
      }).catch(err => {

        this._showErrorMsg(err);
        console.error(err);
        reject(err);
      })
    })
  }

  /**
   * 设置屏幕分享的默认分辨率
   *
   * 如果当前条件不满足自定义屏幕分享的分辨率时，屏幕分享会以默认的960*540的宽高进行分享
   * 目前与阿里云沟通后，已知的屏幕分享时设置分辨率会失败的几个场景：
   *  1、确保没有调用高清预览（enableHighDefinitionPreview），高清预览下设置分辨率不会生效
   *  2、如果浏览器 或则 设备不支持当前分辨率，会设置失败
   *
   * 备注：
   *  chrome内核浏览器，可以通过在新标签页输入 chrome://webrtc-internals/ ，用来观测rtc内流的详细信息
   */
  _setScreenShareResolution() {
    // 默认关闭高清预览。
    // 与阿里云售后沟通，经售后反馈，如果屏幕分享时需要自定义控制分辨率，就必须关闭高清预览。否则设置分享的分辨率时会不生效
    this._client.enableHighDefinitionPreview(false)
    // 获取屏幕浏览器的宽高（不能以屏幕的原始宽高进行设置，比如windows下的任务栏，会占据一定的高度）
    let width = window.screen.availWidth
    let height = window.screen.availHeight
    // 设置屏幕共享时的分辨率
    this._client.setVideoProfile({
      width: width,
      height: height,
      frameRate: 24
    }, 2)

  }

  /**
   * 回调
   */
  _handleEvents() {
    /**
     * 远端用户上线通知
     */
    this._client.on("onJoin", (data) => {
      console.warn("onJoin", data);
      if (this._callBack) {
        this._callBack("onJoin", data);
      }
    })

    /**
     * 远端用户推流通知
     */
    this._client.on("onPublisher", (publisher) => {
      console.warn("onPublisher", publisher);
      // this._executeAutoSubscribe(publisher);
      if (this._callBack) {
        this._callBack("onPublisher", publisher);
      }
    })
    /**
     * 远端用户停止推流通知
     */
    this._client.on("onUnPublisher", (publisher) => {
      console.warn("onUnPublisher 取消流", publisher);
      if (this._checkSubscribeState(publisher.userId)) {
        this._client.unSubscribe(publisher.userId);
      }
      if (this._callBack) {
        this._callBack("onUnPublisher", publisher);
      }
    })
    /**
     * 本地或远端用户的推流状态变化，muteLocalMic，muteLocalCamera操作时会收到回调
     * 返回data为getUserList调用的结果
     */
    this._client.on("onNotify", (data) => {
      console.warn("onNotify", data);
      data.forEach(v => {
        if (this._userId != v.userId) {
          // this._executeAutoMute(v);
          // this._executeVideoMute(v);
        }
      })
      if (this._callBack) {
        this._callBack("onNotify", data);
      }
    })
    /**
     * 角色切换回调
     */
    this._client.on("onUpdateRole", (data) => {
      console.warn(data);
      this._currentRole = data.newRole;
      if (this._currentRole == 0) {
        this.publish().then((re) => {
          this._callBack("onEnterSeatResult", 0);
        }).catch(err => {
          this._callBack("onEnterSeatResult", err);
        });
      } else {
        this._callBack("onLeaveSeatResult", 0);
      }
      if (this._callBack) {
        this._callBack("onUpdateRole", data);
      }
    })
    /**
     * 错误信息
     */
    this._client.on("onError", (error) => {
      console.error('onError', error);
      if (this._callBack) {
        switch (error.errorCode) {
          case 10301:
          case 10302:
          case 10310:
          case 10311:
            // 10301	ERROR_ICE_PUBLISH_DISCONNECTED	推流ice断开。	 网络错误
            // 10302	ERROR_ICE_SUBSCRIBE_DISCONNECTED	订阅ice断开。
            // 10310	ERROR_HEARTBEAT_TIMEOUT	90s心跳超时。
            // 10311	ERROR_NOSESSION	no session。
            this._callBack("onReSubscribe", error);
            break;
          case 10010:
          case 10011:
          case 10012:
          case 10013:
            // 10010	ERROR_SCREENSHARE_UNKNOWNERROR	屏幕共享未知错误。	屏幕共享错误
            // 10011	ERROR_SCREENSHARE_NOTALLOWED	屏幕共享被禁用。
            // 10012	ERROR_SCREENSHARE_ENDED	屏幕共享已取消。
            // 10013	ERROR_SCREENSHARE_NOPERMISSION	屏幕共享系统禁止（mac）。
            this._isScreenSharePreview = false;
            this._callBack("onErrorScreenSharePreview", error);
            break;
          default:
            this._callBack("onError", error);
        }


      }
    })
    /**
     * 被服务器踢出或者频道关闭时回调
     */
    this._client.on("onBye", (data) => {
      console.warn("onBye", data);
      this._isInCall = false
      this.logout()
      if (this._callBack) {
        this._callBack("onBye", data.code);
      }
    })
    /**
     * 远端离开频道回调
     */
    this._client.on("onLeave", (data) => {
      console.warn("onLeave", data);
      if (this._callBack) {
        this._callBack("onLeave", data);
      }
    })
    /**
     * 发布流更新回调
     */
    this._client.on("onPublishChange", (data) => {
      console.log(" onPublishChange data ：", data);
      if (this._callBack) {
        this._callBack("onPublishChange", data);
      }
    })
  }

  /**
   * 注册回调
   */
  registerCallBack(callback) {
    console.log(new Date())
    this._callBack = callback;
  }

  unRegisterCallBack() {
    this._callBack = null;
  }

  /**
   * 获取远端用户在线列表
   */
  getRoomUserList() {
    return this._client.getUserList();
  }


  /**
   * 为远端的视频设置渲染窗口以及绘制参数
   * @param {*} userId 用户ID
   * @param {*} video html中用于显示stream对象的video元素
   * @param {*} streamType 1表示摄像头流（大流和小流），2表示屏幕分享流
   */
  setDisplayRemoteVideo(userId, video, streamType) {
    this._client.setDisplayRemoteVideo(userId, video, streamType);
  }


  /**
   * 设置是否订阅远端音频
   * @param {*} userId
   * @param {*} enable
   */
  configRemoteAudio(userId, enable) {
    this._client.configRemoteAudio(userId, enable);
  }

  /**
   * 设置是否订阅远端屏幕流
   * @param {*} userId
   * @param {*} enable
   */
  configRemoteScreenTrack(userId, enable) {
    //设置是否订阅远端屏幕流。 设置是否订阅远端屏幕流。
    this._client.configRemoteScreenTrack(userId, enable);
  }

  /**
   * 设置是否停止播放远端音频流
   * @param userId 远端用户ID
   * @param muted 是否开启静音 true：开启，false：不开启
   */
  muteRemoteAudioPlaying(userId, muted) {
    console.warn('调用muteRemoteAudioPlaying设置是否停止播放远端音频流， 远端用户ID：{}，是否开启静音：{}', userId, muted)
    this._client.muteRemoteAudioPlaying(userId, muted)
  }

  /**
   * 设置订阅用户音量。
   * <p>
   *     文档官方说明在IOS下不生效。
   * </p>
   * @param userId 远端用户ID
   * @param volume 音量值，取值：[0,1]。
   */
  setAudioVolume(userId, volume) {
    console.warn('调用setAudioVolume设置订阅用户音量， 远端用户ID：{}，音量：{}', userId, volume)
    this._client.setAudioVolume(userId, volume)
  }

  /**
   * 设置是否订阅远端相机流
   * @param {*} userId
   * @param {*} preferMaster true为优先订阅大流，false为优先订阅次小流。
   * @param {*} enable
   */
  configRemoteCameraTrack(userId, preferMaster, enable) {
    this._client.configRemoteCameraTrack(userId, preferMaster, enable);
  }

  /**
   * 调用sdk 订阅
   * @param {*} userId
   */
  _subscribe(userId) {
    return new Promise((resolve, reject) => {
      this._client.subscribe(userId).then(res => {
        resolve()
      }).catch(err => {
        reject(err)
      })
    })
  }

  /**
   * 检查订阅状况
   * @param {*} userId
   * @return {boolean}
   */
  _checkSubscribeState(userId) {
    let streamConfigs = this.getUserInfo(userId).streamConfigs;
    let arr = streamConfigs.filter(v => {
      return v.subscribed
    });
    if (arr.length > 0) {
      return true;
    } else {
      return false;
    }
  }

  /**
   * 获取用户信息
   * @param {*} userId
   */
  getUserInfo(userId) {
    return this._client.getUserInfo(userId);
  }

  /**
   * 根据userId获取推流情况
   * @param {*} userId
   */
  _getPublishStreamConfigs(userId) {
    console.warn('getPublishInfo:', userId);
    let userInfo = this.getUserInfo(userId);
    if (!userInfo || !userInfo.streamConfigs || userInfo.streamConfigs.length <= 0) {
      return [];
    }
    let arr = [];
    const streamConfigs = userInfo.streamConfigs;
    streamConfigs.forEach(item => {
      if (item.state === 'active') {
        arr.push(item);
      }
    })
    console.warn('getPublishInfo:', arr)
    return arr;
  }

  /**
   * 取消订阅设置
   */
  setConfigRemote(userId) {
    return new Promise((resolve, reject) => {
      //demo中只订阅大流
      this._client.configRemoteAudio(userId, false);
      this._client.configRemoteCameraTrack(userId, false, false);
      this._client.configRemoteScreenTrack(userId, false);
      this._client.subscribe(userId).then(re => {
        resolve();
      }).catch(error => console.log("取消订阅失败", error))
    });
  }

  /**
   * 设置具体订阅的流数据
   *
   * @param {*} userId 用户ID
   * @param streamConfigs 当前用户的流状态信息
   */
  setSubscribeStream(userId, streamConfigs = null) {
    return new Promise((resolve, reject) => {
      // 定义订阅流事件的返回内容，返回内容目前包括可以播放的视频画面数量和主画面的类型
      let result = {
        pictureCount: 0, // 当前可用的画面数量，默认为 0
        mainPictureType: 1 // 主画面类型，默认为1。 1：摄像头画面，2：屏幕预览画面
      }
      // 先取消订阅所有的流
      console.log(`ubscirbe userId : 【${userId}】 user streams`)
      this.configRemoteAudio(userId, false)
      this.configRemoteCameraTrack(userId, false, false)
      this.configRemoteScreenTrack(userId, false)

      // 没有传入的用户流状态信息，调用用户个人信息API，从中拿到用户活跃状态的流数据
      if (!streamConfigs || streamConfigs.length <= 0) {
        streamConfigs = this._getPublishStreamConfigs(userId)
      }
      // 如果调用api，仍然查不到活跃的流信息。代表用户未推流或者用户没有在线，就先不订阅用户的流了
      if (!streamConfigs || streamConfigs.length <= 0) {
        resolve(result)
      }
      // 如果当前活跃的流存在音频流，订阅远端音频流
      let index = streamConfigs.findIndex(item => item.label === 'sophon_audio')
      if (index > -1) {
        this.configRemoteAudio(userId, true);
      }
      // 从活跃的流里面过滤出来视频流
      let tempList = streamConfigs.filter(item => item.type === 'video')
      // 如果当前没有活跃的视频流，不做后续的订阅操作
      if (!tempList || tempList.length <= 0) {
        resolve(result)
      }
      // 有活跃的视频流，活跃的视频流的条数，就是可以播放的画面的数量
      // （目前视频流就只有摄像头和屏幕分享流，都可以进行播放）
      result.pictureCount = tempList.length
      // 如果画面数量大于1，即当前屏幕分享流和摄像头流在同时推送。 默认屏幕分享流为主画面流
      if (tempList.length > 1) {
        result.mainPictureType = 2
        // 同时订阅远端屏幕分享流和摄像头流
        this.configRemoteScreenTrack(userId, true)
        this.configRemoteCameraTrack(userId, true, true)
      } else {
        // 否则，根据当前活跃的视频流的label，去判断当前活跃的视频流到底是屏幕分享流还是摄像头流。
        // （只有一路流时，只需要将这路流在主画面展示即可）
        if (tempList[0].label === 'sophon_video_screen_share') {
          result.mainPictureType = 2
          // 订阅远端屏幕分享流
          this.configRemoteScreenTrack(userId, true)
        } else {
          result.mainPictureType = 1
          // 订阅远端摄像头流
          this.configRemoteCameraTrack(userId, true, true)
        }
      }
      // 重新订阅用户的流,并且返回
      this._subscribe(userId).then(res => {
        resolve(result)
      }).catch(err => {
        reject({error: err, result})
      })
    })
  }


  /**
   * 加入直播间
   * @param {*} authInfo 用户加入RTC直播间时的认证信息
   * @param {string} userName 在直播间展示的用户名
   * @returns
   */
  joinChannel(authInfo, userName) {
    return new Promise((resolve, reject) => {
      this._joinChannel(authInfo, userName).then(() => {
        resolve({})
      }).catch(err => {
        console.error(err)
        reject(err)
      })
    })
  }

  /**
   * 加入频道
   * @param authInfo
   * @param userName
   */
  _joinChannel(authInfo, userName) {
    return new Promise((resolve, reject) => {
      this._client.joinChannel(authInfo, userName).then((re) => {
        // 设置当前教师是否在频道中（暂时没有用到）
        this._isInCall = true
        // 默认设置不推流
        this._client.configLocalScreenPublish = false
        this._client.configLocalCameraPublish = false
        // this._client.configLocalAudioPublish = false
        resolve()
      }).catch(err => {
        console.error(err)
        reject({ err })
      })
    })

  }

  /**
   * 销毁实例
   */
  dispose() {
    try {
      this._client.dispose()
    } catch (e) {
      console.log(e)
    }

    RTCClient._instance = null
  }

  /**
   * 用户退出直播间
   * <p>
   *   如果用户在预览中或者在推流中，需要先结束预览和推流，才能离开直播间。
   *   否则浏览器还会提示页面仍在使用麦克风或者摄像头设备。
   * </p>
   * @returns {Promise<unknown>}
   */
  logout() {
    return new Promise((resolve, reject) => {
      // 当前在预览中，且在推流中。 先结束预览，结束预览成功后结束推流，结束推流成功后离开直播间
      if (this._isPreview && this._isPublish) {
        this.stopPreview().then(() => {
          this.unPublish().then(() => {
            this._client.leaveChannel().then(() => {
              this._isInCall = false
              resolve();
            }).catch(err => {
              console.error(err)
              reject(err);
            })
          }).catch(err => {
            console.error(err)
            reject(err)
          })
        }).catch(err => {
          console.error(err)
          reject(err)
        })
      } else if (this._isPreview && !this._isPublish) {
        // 如果当前在预览中，但是并没有推流，那么先结束预览，结束预览后离开直播间
        this.stopPreview().then(() => {
          this._client.leaveChannel().then(() => {
            this._isInCall = false
            resolve();
          }).catch(err => {
            console.error(err)
            reject(err);
          })
        }).catch(err => {
          console.error(err)
          reject(err)
        })
      } else if (!this._isPreview && this._isPublish) {
        // 如果当前在推流中，但是并没有预览，那么先结束推流，结束后再离开直播间
        this.unPublish().then(() => {
          this._client.leaveChannel().then(() => {
            this._isInCall = false
            resolve();
          }).catch(err => {
            console.error(err)
            reject(err);
          })
        }).catch(err => {
          console.error(err)
          reject(err)
        })
      } else {
        // 即没在推流中也没在预览中，直接退出直播间
        this._client.leaveChannel().then(() => {
          this._isInCall = false
          resolve();
        }).catch(err => {
          console.error(err)
          reject(err);
        })
      }
    })
  }

  /**
   * 设置是否禁用本地麦克风采集的标志位
   * 如果当前正在推流中，同时调用rtc的接口，禁止本地麦克风采集
   *
   * @param {boolean} isMuteLocalMic 是否禁止采集本地麦克风。默认为false
   * @return {boolean}
   */
  muteLocalMic(isMuteLocalMic = false) {
    this._isMuteLocalMic = isMuteLocalMic;
    if (this._isPublish) {
      // 该接口需要在推流状态下设置有效
      return this._client.muteLocalMic(this._isMuteLocalMic)
    } else {
      return true
    }
  }

  /**
   * 是否停止本地视频采集
   * 。
   * @param {*} isMuteLocalMic 是否进制采集本地摄像头。 true时禁止采集，false时允许采集
   * @return {boolean}
   */
  muteLocalCamera(isMuteLocalMic = false) {
    this._isMuteLocalCamera = isMuteLocalMic
    // rtc的禁止本地麦克风采集接口，只有在推流且是本机摄像头推流的状态下可以设置。
    if (this._isPublish && this._client.configLocalCameraPublish) {
      // 该接口需要在推流状态下设置有效
      return this._client.muteLocalCamera(this._isMuteLocalCamera)
    } else {
      return true
    }
  }


  /**
   * 获取鉴权信息
   */
  getAuthInfo(token, classIdCode, scence, userType, gardenId) {
    return new Promise((resolve, reject) => {
      WebRtcService.getRtcToken({
        yk_user_token: token,
        req_class_id_code: classIdCode,
        req_scence: scence,
        user_type: userType,
        gid: gardenId
      }).then(res => {
        // 响应成功
        if (res.Code === 200) {
          let data = res.Data
          this._userId = data.RtcUserID
          let authInfo = {
            appid: data.AppID,
            userid: data.RtcUserID,
            timestamp: data.Timestamp,
            nonce: data.Nonce,
            token: data.RtcToken,
            gslb: data.GSLB,
            channel: classIdCode
          }
          resolve(authInfo)
        } else {
          console.warn(`error Code : 【${res.Code}】, error developer message：【${res.Message.DeveloperMsg}】, error user message：【${res.Message.UserMsg}】`)
          reject({ Code: res.Code, Message: res.Message })
        }
        // else if (res.Code === 701) {
        //   //  用户的优课场域认证token时效
        // } else if (res.Code === 700) {
        //   //  云端未知异常
        // } else if (res.Code === 702) {
        //   //  云端获取园区对应的rtc AppID和appkey 报错
        // } else if (res.Code === 703) {
        //   //  云端获取当前频道ID的可用性时报错
        // } else if (res.Code === 704) {
        //   // 当前请求的频道ID不可用
        // }
      }).catch(err => {
        // 接口访问异常，返回自定义的响应码500和自定义的异常内容
        reject({
          Code: 500,
          Message: {
            UserMessage: '向云端获取马良笔双师课堂用户凭证时失败，请联系系统管理员。'
          }
        })
        reject(err)
      })
    })
  }

  /**
   * 预览本地摄像头
   * @param {*} video
   */
  startPreview(video) {
    return new Promise((resolve, reject) => {
      //startPreview：预览本地摄像头 stopPreview：结束预览本地摄像头
      this._client.startPreview(video).then(() => {
        setTimeout(() => {
          // this._localCameraStream = video.srcObject;
          resolve();
        }, 10)
      }).catch(err => {
        reject(err);
        console.error(err);
      })
    })
  }

  /**
   * 结束预览本地摄像头
   */
  stopPreview() {
    return new Promise((resolve, reject) => {
      this._client.stopPreview().then(() => {
        resolve();
      }).catch(err => {
        reject(err);
        console.error(err);
      })
    })
  }

  /**
   * 开启屏幕分享预览
   *
   * 共享屏幕声音支持Windows端Chrome 75及以上版本或Edge 80及以上版本，Mac端仅支持分享标签页声音。
   * @param {*} video
   */
  startScreenSharePreview(video) {
    return new Promise((resolve, reject) => {
      /**
       * 设置视频/屏幕流参数
       * @param {Number} width 宽度   摄像头：640（默认值）。屏幕共享：960（默认值
       * @param {Number} height 高度   摄像头：480（默认值）。屏幕共享：540（默认值）
       * @param {Number} frameRate 帧率  取值范围：5~30。取值：摄像头：15（默认值）。屏幕共享：10（默认值）
       * @param {Number} type 类型 1：摄像头流 2：共享流
       *
       * 宽高比是 16/9
       */
      this._client.setVideoProfile({
        width: 1920,
        height: 1080,
        frameRate: 30
      }, 2)
      this._client.startScreenSharePreview(video).then(() => {
        this._isScreenSharePreview = true
        this._isPreview = false
        resolve()
      }).catch(err => {
        reject(err);
      })
    })
  }

  /**
   * 停止屏幕分享预览
   */
  stopScreenSharePreview() {
    return new Promise((resolve, reject) => {
      if (this._isScreenSharePreview) {
        this._client.stopScreenSharePreview().then(() => {
          this._isScreenSharePreview = false;
          resolve();
        }).catch(err => {
          reject(err);
          console.error(err);
        })
      } else {
        resolve();
      }
    })
  }

  /**
   * 设置本地的摄像头流的分享状态
   * @param publish
   */
  setLocalCameraPublishStatus(publish = false) {
    // 设置摄像头流的推送状态
    this._client.configLocalCameraPublish = publish
  }

  setLocalAudioPublishStatus(publish = false) {
    this._client.configLocalAudioPublish = publish
  }

  /**
   * 获取当前是否支持屏幕分享
   * @returns {*}
   */
  isSupportScreenShare() {
    return this._client.isSupportScreenShare()
  }

  /**
   * 设置屏幕流的发布状态。
   * <p>
   *   如果当前设备支持屏幕流分享，则根据传入的分享状态参数，设置屏幕流是否分享，并且返回成功；
   *   如果当前设备不支持屏幕流分享，不论传入的分享状态是什么，统一将屏幕流分享状态设置为false，并且返回失败。
   * </p>
   * @param publish 分享状态，默认为false。
   */
  setScreenPublishStatus(publish = false) {
    this._client.configLocalScreenPublish = publish

  }

  /**
   * 调用sdk推流
   */
  publish() {
    return new Promise((resolve, reject) => {
      this._client.publish().then(() => {
        this._isPublish = true
        resolve(true);
      }).catch(err => {
        console.error(err)
        reject(err);
      })
    })
  }

  /**
   * 停止推流
   *
   * 设置客户端禁止推送麦克风、摄像头和屏幕后，重新推流。
   *
   * PS：官方SDK从1.14之后，开始取消unPublish接口，建议设置config后调用publish接口。
   * 所以这里采用设置所有内容均为不可推送后，调用publish接口，而非直接调用unPublish接口。
   */
  unPublish() {
    return new Promise((resolve, reject) => {
      this._client.configLocalAudioPublish = false
      this._client.configLocalCameraPublish = false
      this._client.configLocalScreenPublish = false
      this._client.publish().then(re => {
        this._isPublish = false
        resolve(re)
      }).catch(err => {
        console.error(err);
        reject(err);
      })
    })
  }

}
